module.exports = __webpack_public_path__ + "d3056ff016828b95fba93746b9f0440d.svg";